// src/components/Home.js
import React from 'react';
import styles from './Home.module.css';
import Slider from "react-slick"; // Carousel

function Home() {
  // Images for slideshow – update with your real filenames
  const slides = [
    {src: "/logo.png", alt: "School Logo"},
    {src: "/welcome.jpg", alt: "Students welcome"},
    {src: "/headteacher.jpg", alt: "School compound"},
    {src: "/staff1.jpg", alt: "School compound"},
    {src: "/2.jpg", alt: "Classroom"},
    {src: "/staff3.jpg", alt: "Classroom"},
    {src: "/staff4.jpg", alt: "Classroom"},
    {src: "/staff5.jpg", alt: "Classroom"},
    {src: "/staff2.jpg", alt: "Classroom"},
    {src: "/5.jpg", alt: "Classroom"},
    {src: "/23.jpg", alt: "Classroom"},
    {src: "/staff8.jpg", alt: "Classroom"},
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true
  };

  return (
    <section className={styles.home}>
      <div className={styles.logoBanner}>
  <img src="/logo.png" alt="Destiny Kids School Logo" className={styles.logoImg} />
  <h1>Welcome to Destiny Kids Nursery & Primary School</h1>
</div>
      <h2 className={styles.motto}>"Knowledge is Wealth"</h2>
      <Slider {...sliderSettings} className={styles.slider}>
        {slides.map((slide, idx) => (
          <div key={idx} className={styles.slide}>
            <img src={slide.src} alt={slide.alt} className={styles.slideImg}/>
          </div>
        ))}
      </Slider>
      <p>
        Creating a centre of excellence for 620 learners since 2016. We provide a caring, ambitious, and holistic educational experience, empowering pupils to lift their eyes, raise themselves and others, and become Africa’s next generation of servant leaders.
      </p>
     <div className={styles.infoCard}>
  <div><strong>Location:</strong> Mauna near Suk Ardep, Juba South Sudan</div>
  <div><strong>Contact:</strong> +211922590325, +211926135385, +211922558399</div>
</div>
    </section>
  );
}

export default Home;
